(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hat-configurator"]) return;
  try {
    
const hatImg = document.getElementById("hat-image");
const logoImg = document.getElementById("preview-logo");
const resizable = document.getElementById("resizable-logo");
const patchOverlay = document.getElementById("patch-overlay");
const colorSwatches = document.getElementById("color-swatches");
const stitchingSection = document.getElementById("stitching-option");
const stitchingButtons = document.querySelectorAll("#stitching-swatches .stitching-button");

let selectedStitching = "black"; // default
let uploadedLogoBase64 = null;
let originalLogoDataURL = null; // Store original image as DataURL

stitchingButtons.forEach(button => {
  button.addEventListener("click", () => {
    stitchingButtons.forEach(b => b.classList.remove("selected"));
    button.classList.add("selected");
    selectedStitching = button.dataset.stitch;

    // Filter sewn patches by stitching color
    document.querySelectorAll('#patch-swatches .swatch[data-category="sewn"]').forEach(patch => {
      const patchName = patch.dataset.patch.toLowerCase();
      const isVisible = selectedStitching === "white"
    ? patchName.includes("with_white")
    : patchName.includes("with_black") || patchName.includes("with_brown");
      patch.style.display = isVisible ? "block" : "none";
    });

    // Clear selected patch and overlays
    document.querySelectorAll('#patch-swatches .swatch').forEach(s => s.classList.remove('selected'));
    patchOverlay.style.display = "none";
    logoImg.style.display = "none";
    updatePrice();
    filterDropdownByCategory("sewn", selectedStitching);
  });
});

function getLogoStyleByShape(patchFile) {
  const shape = patchFile.toLowerCase();
  const isMobile = window.innerWidth < 768;

  const size = isMobile ? "25px" : "60px";     // for oval, square, rectangle
  const small = isMobile ? "22px" : "55px";    // for hex, badge
  const circle = isMobile ? "28px" : "65px";   // for circle shapes

  if (shape.includes("circle")) {
    return { top: "39%", width: circle };
  } else if (shape.includes("oval")) {
    return { top: "38%", width: size };
  } else if (shape.includes("rectangle") || shape.includes("vert")) {
    return { top: "38%", width: size };
  } else if (shape.includes("square") || shape.includes("sqaure")) {
    return { top: "38%", width: size };
  } else if (shape.includes("badge")) {
    return { top: "37.5%", width: small };
  } else if (shape.includes("hex")) {
    return { top: "38%", width: small };
  } else {
    return { top: "43%", width: isMobile ? "50px" : "90px" }; // fallback
  }
}

const hatVariants = {
  "112": [
    "112_Split-Black-Charcoal_FRONT.jpg",
    "112_Split-Charcoal-Black_FRONT.jpg",
    "112_Split-Loden-Black_FRONT.jpg",
    "112_Split-Khaki-Coffee_FRONT.jpg",
    "112_Split-HeatherGrey-Black_FRONT.jpg",
    "112_Solid-Black_FRONT.jpg"
  ],
  "115": [
    "115_Black_FRONT.jpg",
    "115_Black-Charcoal_FRONT.jpg",
    "115_Caramel-Black_FRONT.jpg",
    "115_Charcoal-Black_FRONT.jpg",
    "115_Loden-Black_FRONT.jpg",
    "115_Brown-Khaki_FRONT.jpg",
    "115_HeatherGrey-DarkCharcoal_FRONT.jpg"
  ],
  "168": [
    "168_Black_FRONT.jpg",
    "168_Charcoal-BurntOrange-Black_FRONT.jpg",
    "168_Caramel_FRONT.jpg",
    "168_Charcoal-Black_FRONT.jpg",
    "168_Quarry_FRONT.jpg"
  ],
  "217": [
    "217_Black_FRONT.jpg",
    "217_HeatherGrey-Black_FRONT.jpg",
    "217_HeatherGrey_FRONT.jpg",
    "217_LightNavy_FRONT.jpg",
    "217_DarkLoden-Biscuit_FRONT.jpg"
  ],
  "256": [
    "256_Black-Black_FRONT.jpg",
    "256_Birch-Black_FRONT.jpg",
    "256_Biscuit-Black_FRONT.jpg",
    "256_Charcoal-White_FRONT.jpg"
  ],
  "935": [
    "935_Black-Charcoal_FRONT.jpg",
    "935_Navy_FRONT.jpg",
    "935_Charcoal-Cyan_FRONT.jpg",
    "935_Teal-Orange_FRONT.jpg",
    "935_Khaki_FRONT.jpg"
  ]
};

const hatStyleLabels = {
  "112": "Richardson 112",
  "115": "Richardson 115",
  "168": "Richardson 168",
  "217": "Richardson 217",
  "256": "Richardson 256",
  "935": "Richardson 935"
};

const patchNameMap = {
  // HEATPRESSED
  "Brown_Rectangle_1A.png": "Brown/Rectangle",
  "Brown_Square_1A.png": "Brown/Square",
  "Brown_Circle_1A.png": "Brown/Circle",
  "Brown_Badge_1A.png": "Brown/Badge",
  "Brown_Block_1A.png": "Brown/Block",
  "Brown_Hex_1A.png": "Brown/Hex",
  "Brown_Oval_1A.png": "Brown/Oval",
  "Brown_Vert_Rectangle_1A.png": "Brown/Vertical Rectangle",

  "Black_Rectangle_1A.png": "Black/Rectangle",
  "Black_Square_1A.png": "Black/Square",
  "Black_Circle_1A.png": "Black/Circle",
  "Black_Badge_1A.png": "Black/Badge",
  "Black_Block_1A.png": "Black/Block",
  "Black_Hex_1A.png": "Black/Hex",
  "Black_Oval_1A.png": "Black/Oval",
  "Black_Vertical_Rectangle_1A.png": "Black/Vertical Rectangle",

  "Stone_Grey_Rectangle_1A.png": "Grey/Rectangle",
  "Stone_Grey_Vertical_Square_1A.png": "Grey/Square",
  "Stone_Grey_Circle_1A.png": "Grey/Circle",
  "Stone_Grey_Badge_1A.png": "Grey/Badge",
  "Stone_Grey_Block_1A.png": "Grey/Block",
  "Stone_Grey_Hex_1A.png": "Grey/Hex",
  "Stone_Grey_Oval_1A.png": "Grey/Oval",
  "Stone_Grey_Vertical_Rectangle_1A.png": "Grey/Vertical Rectangle",

  "Gun_Metal_Rectangle_1A.png": "Metal/Rectangle",
  "Gun_Metal_Square_1A.png": "Metal/Square",
  "Gun_Metal_Circle_1A.png": "Metal/Circle",
  "Gun_Metal_Badge_1A.png": "Metal/Badge",
  "Gun_Metal_Block_1A.png": "Metal/Block",
  "Gun_Metal_Hex_1A.png": "Metal/Hex",
  "Gun_Metal_Oval_1A.png": "Metal/Oval",
  "Gun_Metal_Vert_Rectangle_1A.png": "Metal/Vertical Rectangle",

  // SEWN (includes D = Dark Stitching, L = Light Stitching)
  "Brown_with_Brown_Rectangle_1A.png": "Brown/Rectangle/D",
  "Brown_with_Brown_Square_1A.png": "Brown/Square/D",
  "Brown_with_Brown_Circle_1A.png": "Brown/Circle/D",
  "Brown_with_Brown_Badge_1A.png": "Brown/Badge/D",
  "Brown_with_Brown_Hex_1A.png": "Brown/Hex/D",
  "Brown_with_Brown_Oval_1A.png": "Brown/Oval/D",
  "Brown_with_Brown_Vertical_Rectangle_1A.png": "Brown/Vertical Rectangle/D",

  "Brown_with_White_Rectangle_1A.png": "Brown/Rectangle/L",
  "Brown_with_White_Square_1A.png": "Brown/Square/L",
  "Brown_with_White_Circle_1A.png": "Brown/Circle/L",
  "Brown_with_White_Badge_1A.png": "Brown/Badge/L",
  "Brown_with_White_Hex_1A.png": "Brown/Hex/L",
  "Brown_with_White_Oval_1A.png": "Brown/Oval/L",
  "Brown_with_White_Vertical_Rectangle_1A.png": "Brown/Vertical Rectangle/L",

  "Black_with_Black_Rectangle_1A.png": "Black/Rectangle/D",
  "Black_with_Black_Sqaure_1A.png": "Black/Square/D",
  "Black_with_Black_Circle_1A.png": "Black/Circle/D",
  "Black_with_Black_Badge_1A.png": "Black/Badge/D",
  "Black_with_Black_Hex_1A.png": "Black/Hex/D",
  "Black_with_Black_Oval_1A.png": "Black/Oval/D",
  "Black_with_Black_Vertical_Rectangle_1A.png": "Black/Vertical Rectangle/D",

  "Black_with_White_Rectangle_1A.png": "Black/Rectangle/L",
  "Black_with_White_Square_1A.png": "Black/Square/L",
  "Black_with_White_Circle_1A.png": "Black/Circle/L",
  "Black_with_White_Badge_1A.png": "Black/Badge/L",
  "Black_with_White_Hex_1A.png": "Black/Hex/L",
  "Black_with_White_Oval_1A.png": "Black/Oval/L",
  "Black_with_White_Vertical_Rectangle_1A.png": "Black/Vertical Rectangle/L",

  "Charcoal_with_Black_Rectangle_1A.png": "Grey/Rectangle/D",
  "Charcoal_with_Black_Square_1A.png": "Grey/Square/D",
  "Charcoal_with_Black_Circle_1A.png": "Grey/Circle/D",
  "Charcoal_with_Black_Badge_1A.png": "Grey/Badge/D",
  "Charcoal_with_Black_Hex_1A.png": "Grey/Hex/D",
  "Charcoal_with_Black_Oval_1A.png": "Grey/Oval/D",
  "Charcoal_with_Black_Vertical_Rectangle_1A.png": "Grey/Vertical Rectangle/D",

  "Charcoal_with_White_Rectangle_1A.png": "Grey/Rectangle/L",
  "Charcoal_with_White_Square_1A.png": "Grey/Square/L",
  "Charcoal_with_White_Circle_1A.png": "Grey/Circle/L",
  "Charcoal_with_White_Badge_1A.png": "Grey/Badge/L",
  "Charcoal_with_White_Hex_1A.png": "Grey/Hex/L",
  "Charcoal_with_White_Oval_1A.png": "Grey/Oval/L",
  "Charcoal_with_White_Vertical_Rectangle_1A.png": "Grey/Vertical Rectangle/L"
};
  
function updateColorSwatches(styleKey) {
  colorSwatches.innerHTML = "";
  const variants = hatVariants[styleKey];
  variants.forEach(filename => {
    const swatch = document.createElement("div");
    swatch.className = "swatch";
    swatch.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${filename}')`;
    swatch.dataset.image = filename;

    swatch.addEventListener("click", () => {
      document.querySelectorAll("#color-swatches .swatch").forEach(s => s.classList.remove("selected"));
      swatch.classList.add("selected");
      hatImg.src = `https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${filename}`;
    });

    colorSwatches.appendChild(swatch);
  });

  if (variants.length > 0) {
    hatImg.src = `https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${variants[0]}`;
    colorSwatches.children[0].classList.add("selected");
  }
}

document.querySelectorAll("#hat-style-swatches .swatch").forEach(swatch => {
  swatch.addEventListener("click", () => {
    document.querySelectorAll("#hat-style-swatches .swatch").forEach(s => s.classList.remove("selected"));
    swatch.classList.add("selected");
    const selectedStyle = swatch.dataset.style;
    updateColorSwatches(selectedStyle);
    document.getElementById("hat-style-label").textContent = hatStyleLabels[selectedStyle] || "Not selected";
  });
});

document.getElementById("logo-upload").addEventListener("change", e => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    uploadedLogoBase64 = reader.result;

    document.getElementById("original-logo-base64").value = uploadedLogoBase64;

    const patchSrc = patchOverlay?.src || "";
    applyEngravedEffect(uploadedLogoBase64, patchSrc);
  };
  reader.readAsDataURL(file);
});

function applyEngravedEffect(base64, patchSrc) {
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(img, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    let patchColor = { r: 90, g: 60, b: 30 }; // default brown
    const src = patchSrc.toLowerCase();

    if (src.includes("grey")) {
      patchColor = { r: 80, g: 80, b: 80 };
    } else if (src.includes("black")) {
      patchColor = { r: 40, g: 40, b: 40 };
    } else if (src.includes("metal")) {
      patchColor = { r: 100, g: 100, b: 100 };
    } else if (src.includes("brown")) {
      patchColor = { r: 90, g: 60, b: 30 };
    }

    for (let i = 0; i < data.length; i += 4) {
      const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];

      if (a === 0) continue;

      const brightness = 0.299 * r + 0.587 * g + 0.114 * b;

      if (brightness > 200) {
        data[i + 3] = 0; // make light pixels transparent
      } else if (brightness > 130) {
        data[i] = patchColor.r;
        data[i + 1] = patchColor.g;
        data[i + 2] = patchColor.b;
        data[i + 3] = 80; // semi-transparent
      } else {
        data[i] = patchColor.r;
        data[i + 1] = patchColor.g;
        data[i + 2] = patchColor.b;
        data[i + 3] = 255; // fully opaque
      }
    }

    ctx.putImageData(imageData, 0, 0);
    const finalImage = canvas.toDataURL();

    const previewLogo = document.getElementById("preview-logo");
    previewLogo.src = finalImage;
    previewLogo.style.display = "block";
    document.getElementById("resizable-logo").style.display = "block";
  };

  img.src = base64;
}
  
document.querySelectorAll("#patch-swatches .swatch").forEach(swatch => {
  swatch.addEventListener("click", () => {
    document.querySelectorAll("#patch-swatches .swatch").forEach(s => s.classList.remove("selected"));
    swatch.classList.add("selected");

    const patchFile = swatch.dataset.patch;
    patchOverlay.src = `https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${patchFile}`;
    patchOverlay.style.display = "block";

    // Adjust logo position/size based on selected patch
    const logoStyle = getLogoStyleByShape(patchFile);
    if (logoStyle) {
      resizable.style.top = logoStyle.top || "45%";
      logoImg.style.width = logoStyle.width || "90px";
    } else {
      // Fallback/default
      logoImg.style.top = "45%";
      logoImg.style.width = "90px";
    }
    if (uploadedLogoBase64) {
      applyEngravedEffect(uploadedLogoBase64, patchOverlay.src);
    }
  });
});
  
document.querySelectorAll('#patch-category-buttons .swatch').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('#patch-category-buttons .swatch').forEach(b => b.classList.remove('selected'));
    button.classList.add('selected');

    const selectedCategory = button.dataset.category;

    filterDropdownByCategory(selectedCategory, selectedStitching);

    // Show stitching selector only if "sewn"
    if (selectedCategory === "sewn") {
      stitchingSection.style.display = "block";
    } else {
      stitchingSection.style.display = "none";
    }

    // Filter swatches
    document.querySelectorAll('#patch-swatches .swatch').forEach(patch => {
      patch.style.display = (
        patch.dataset.category === selectedCategory &&
        (selectedCategory === "heatpress" || patch.dataset.patch.toLowerCase().includes(`with_${selectedStitching}`))
      ) ? 'block' : 'none';
    });

    document.querySelectorAll('#patch-swatches .swatch').forEach(s => s.classList.remove('selected'));
    patchOverlay.style.display = "none";
    logoImg.style.display = "none";
    updatePrice();
  });
});

const patchDropdown = document.getElementById("patch-dropdown");

patchDropdown.addEventListener("change", (e) => {
  const selectedOption = patchDropdown.options[patchDropdown.selectedIndex];
  const patchFile = selectedOption.value;
  const category = selectedOption.dataset.category;

  if (!patchFile) return;

  patchOverlay.src = `https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${patchFile}`;
  patchOverlay.style.display = "block";

  const logoStyle = getLogoStyleByShape(patchFile);
  if (logoStyle) {
  resizable.style.top = logoStyle.top || "45%";
  resizable.querySelector("img").style.width = logoStyle.width || "90px";
  }
   else {
    resizable.style.top = "45%";
    logoImg.style.width = "90px";
  }

  // Deselect all desktop swatches (in case user switched back)
  document.querySelectorAll('#patch-swatches .swatch').forEach(s => s.classList.remove('selected'));

  // Store selection to support pricing and cart
  patchDropdown.dataset.selectedPatch = patchFile;
  patchDropdown.dataset.selectedCategory = category;

  logoImg.style.display = "block";
  updatePrice();
  
  if (uploadedLogoBase64) {
  applyEngravedEffect(uploadedLogoBase64, patchOverlay.src);
 }
});
  
updateColorSwatches("112");
document.querySelector(`#hat-style-swatches .swatch[data-style="112"]`).classList.add("selected");
document.getElementById("hat-style-label").textContent = hatStyleLabels["112"];
  const pricingTable = {
  sewn: {
    A: {
      "1": 35.95,
      "2-4": 32.95,
      "5-9": 26.72,
      "10-24": 24.00,
      "25-49": 22.00,
      "50-99": 21.00,
      "100+": 20.00
    },
    B: {
      "1": 36.95,
      "2-4": 33.95,
      "5-9": 27.72,
      "10-24": 25.00,
      "25-49": 23.00,
      "50-99": 22.00,
      "100+": 21.00
    },
    C: {
      "1": 39.95,
      "2-4": 36.95,
      "5-9": 30.12,
      "10-24": 27.00,
      "25-49": 25.00,
      "50-99": 24.00,
      "100+": 23.00
    }
  },
  heatpress: {
    A: {
      "1": 31.95,
      "2-4": 28.95,
      "5-9": 22.72,
      "10-24": 20.00,
      "25-49": 18.00,
      "50-99": 17.00,
      "100+": 16.00
    },
    B: {
      "1": 32.95,
      "2-4": 29.95,
      "5-9": 23.72,
      "10-24": 21.00,
      "25-49": 19.00,
      "50-99": 18.00,
      "100+": 17.00
    },
    C: {
      "1": 35.95,
      "2-4": 32.95,
      "5-9": 26.72,
      "10-24": 24.00,
      "25-49": 22.00,
      "50-99": 21.00,
      "100+": 20.00
    }
  }
};

const variantMap = {
  heatpress: {
    A: {
      "1": 50459738112288,
      "2-4": 50459747123488,
      "5-9": 50459747156256,
      "10-24": 50459747189024,
      "25-49": 50459747221792,
      "50-99": 50459747254560,
      "100+": 50459747287328
    },
    B: {
      "1": 50459738145056,
      "2-4": 50459747516704,
      "5-9": 50459747549472,
      "10-24": 50459747582240,
      "25-49": 50459747615008,
      "50-99": 50459747647776,
      "100+": 50459747680544
    },
    C: {
      "1": 50459738177824,
      "2-4": 50459747909920,
      "5-9": 50459747942688,
      "10-24": 50459747975456,
      "25-49": 50459748008224,
      "50-99": 50459748040992,
      "100+": 50459748073760
    }
  },
  sewn: {
    A: {
      "1": 50454728474912,
      "2-4": 50459746926880,
      "5-9": 50459746959648,
      "10-24": 50459746992416,
      "25-49": 50459747025184,
      "50-99": 50459747057952,
      "100+": 50459747090720
    },
    B: {
      "1": 50459736047904,
      "2-4": 50459747320096,
      "5-9": 50459747352864,
      "10-24": 50459747385632,
      "25-49": 50459747418400,
      "50-99": 50459747451168,
      "100+": 50459747483936
    },
    C: {
      "1": 50459736080672,
      "2-4": 50459747713312,
      "5-9": 50459747746080,
      "10-24": 50459747778848,
      "25-49": 50459747811616,
      "50-99": 50459747844384,
      "100+": 50459747877152
    }
  }
};

function getQtyBracket(qty) {
  if (qty === 1) return "1";
  if (qty >= 2 && qty <= 4) return "2-4";
  if (qty >= 5 && qty <= 9) return "5-9";
  if (qty >= 10 && qty <= 24) return "10-24";
  if (qty >= 25 && qty <= 49) return "25-49";
  if (qty >= 50 && qty <= 99) return "50-99";
  return "100+";
}
  
const pricingDisplay = document.createElement("div");
pricingDisplay.className = "pricing-display";
document.querySelector("#quantity").parentElement.after(pricingDisplay);

function updatePrice() {
  const quantity = parseInt(document.getElementById("quantity").value) || 1;

  const hatStyleSwatch = document.querySelector("#hat-style-swatches .swatch.selected");
  const patchSwatch = document.querySelector("#patch-swatches .swatch.selected");
  
  // NEW LOGIC
  let patch = patchSwatch?.dataset.patch || patchDropdown.dataset.selectedPatch || "";
  let method = patchSwatch?.dataset.category || patchDropdown.dataset.selectedCategory || "heatpress";

  if (!hatStyleSwatch || !patch) {
    pricingDisplay.textContent = "";
    return;
  }

  const style = hatStyleSwatch.dataset.style;
  const styleGroup = ["112", "115"].includes(style) ? "A" : ["168", "217"].includes(style) ? "B" : "C";

  const priceTable = pricingTable[method][styleGroup];
  const qtyBracket = getQtyBracket(quantity);
  const unitPrice = priceTable[qtyBracket];
  const totalPrice = (unitPrice * quantity).toFixed(2);

  pricingDisplay.textContent = `Price per Hat: $${unitPrice.toFixed(2)} | Total: $${totalPrice}`;
}

// Update on quantity change
document.getElementById("quantity").addEventListener("input", updatePrice);

// Hook into hat + patch selection
document.querySelectorAll("#hat-style-swatches .swatch, #patch-swatches .swatch").forEach(swatch => {
  swatch.addEventListener("click", updatePrice);
});

function getLogoData() {
  return {
    top: logoImg.style.top || "N/A",
    left: logoImg.style.left || "N/A",
    width: logoImg.style.width || "N/A"
  };
}
  
function addToCart() {
  const quantity = parseInt(document.getElementById("quantity").value) || 1;

  const hatStyle = document.querySelector("#hat-style-swatches .swatch.selected")?.dataset.style || "Not selected";
  const colorImage = document.querySelector("#color-swatches .swatch.selected")?.dataset.image || "Not selected";
let patchSwatch = document.querySelector("#patch-swatches .swatch.selected");
let patchImage = "Not selected";
let patchCategory = "Not selected";

if (patchSwatch) {
  patchImage = patchSwatch.dataset.patch;
  patchCategory = patchSwatch.dataset.category;
} else if (patchDropdown.value) {
  patchImage = patchDropdown.dataset.selectedPatch || patchDropdown.value;
  patchCategory = patchDropdown.dataset.selectedCategory || "heatpress";
}

  const stitching = (patchCategory === "sewn") ? selectedStitching : "N/A";

  const logoDataURL = logoImg.src || "No logo uploaded";
  const logoPlacement = getLogoData();

  const styleGroup = ["112", "115"].includes(hatStyle) ? "A" : ["168", "217"].includes(hatStyle) ? "B" : "C";
  const variantId = variantMap[patchCategory]?.[styleGroup]?.[getQtyBracket(quantity)] || 50454728474912;
  
  const formData = {
    items: [{
      quantity: quantity,
      id: variantId,
      properties: {
        "Hat Style": hatStyle,
        "Hat Color": colorImage,
        "Patch Type": patchImage,
        "Patch Category": patchCategory,
        "Stitching": stitching,
        "_Logo Image (Original)": document.getElementById("original-logo-base64").value || "Not provided",
        "_Logo Image (Preview)": logoImg.src || "No logo uploaded",
        "Logo File": logoImg.src.includes("base64") ? document.getElementById("logo-upload").files[0]?.name || "Uploaded Logo" : "No logo uploaded",
      }
    }]
  };

  fetch("/cart/add.js", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(formData)
})
.then(() => {
  window.location.href = "/cart";
})
.catch(err => {
  alert("Failed to add to cart. Please try again.");
  console.error(err);
});
}
window.addToCart = addToCart;

function filterDropdownByCategory(category, stitching) {
  const dropdown = document.getElementById("patch-dropdown");

  // Save all original options once
  if (!dropdown.dataset.initialized) {
    dropdown.dataset.initialized = "true";
    dropdown.originalOptions = Array.from(dropdown.querySelectorAll("option"));
  }

  // Clear current options
  dropdown.innerHTML = "";

  const filtered = dropdown.originalOptions.filter(option => {
    const optCat = option.dataset.category;
    const patchName = option.dataset.patch.toLowerCase();

    if (category === "sewn") {
      if (stitching === "white") {
        return optCat === "sewn" && patchName.includes("with_white");
      } else {
        return optCat === "sewn" && (patchName.includes("with_black") || patchName.includes("with_brown"));
      }
    }

    return optCat === category;
  });

  filtered.forEach(option => {
    if (patchNameMap[option.dataset.patch]) {
    option.textContent = patchNameMap[option.dataset.patch];
    }
    dropdown.appendChild(option);
  });

  // Select first visible option
  if (dropdown.options.length > 0) {
    dropdown.value = dropdown.options[0].value;
    dropdown.dataset.selectedPatch = dropdown.options[0].dataset.patch;
    dropdown.dataset.selectedCategory = dropdown.options[0].dataset.category;
    updatePrice();

  if (uploadedLogoBase64) {
    const newPatchSrc = `https://cdn.shopify.com/s/files/1/0809/8748/8544/files/${dropdown.dataset.selectedPatch}`;
    applyEngravedEffect(uploadedLogoBase64, newPatchSrc);
    }
  }
}

filterDropdownByCategory("heatpress", selectedStitching);

if (uploadedLogoBase64) {
  const patchSrc = patchOverlay?.src || "";
  applyEngravedEffect(uploadedLogoBase64, patchSrc);
}

const patchDropdownOptions = document.querySelectorAll("#patch-dropdown option");

patchDropdownOptions.forEach(option => {
  const patchFile = option.dataset.patch;
  if (patchNameMap[patchFile]) {
    option.textContent = patchNameMap[patchFile];
  }
});
  
const lazySwatches = document.querySelectorAll('.swatch[data-bg]');

const lazyObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const swatch = entry.target;
      const bg = swatch.getAttribute('data-bg');
      if (bg) {
        swatch.style.backgroundImage = `url('${bg}')`;
        swatch.removeAttribute('data-bg');
        observer.unobserve(swatch);
      }
    }
  });
}, {
  rootMargin: '200px', // Start loading before they appear
});

lazySwatches.forEach(swatch => lazyObserver.observe(swatch));


  } catch(e) { console.error(e); }
})();
})();
